$K.init();

function charcountupdate(str) {
  var lng = str.length;
	document.getElementById("charcount").innerHTML = lng + '/1200';
}

new SimpleLightbox({elements: '.gallery a'});

var gliderElement = document.querySelector('.glider');

if (gliderElement) {
  new Glider(gliderElement, {
    slidesToShow: 6,
    slidesToScroll: 6,
    rewind: true,
    arrows: {
      prev: '.g-prev',
      next: '.g-next'
    },
    responsive: [
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 2
        }
      }
    ]
  });
}
